// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"10e2e935","703":"a16da1ab"}[chunkId] + ".chunk.js";
};